import React from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'

function SellerAsideLoader({ numLiveData }) {
    return (
        <>
            {[...Array(numLiveData)].map((_, index) => (
                <div
                    key={index}
                    className="border-radius-12 white mb-1"
                    style={{
                        border: "1px solid #6f2da8",
                        padding: "0.5rem 0.8rem",
                    }}
                >
                    <SkeletonTheme color="#cfcfcf" highlightColor="#e0e0e0">
                        <div className="valign-wrapper space-between">
                            <Skeleton width={120} height={20} />
                            <Skeleton width={60} height={20} />
                        </div>
                        <Skeleton count={2} />
                        <Skeleton
                            width={100}
                            height={20}
                            style={{ marginTop: "0.5rem" }}
                        />
                    </SkeletonTheme>
                </div>
            ))}
        </>
    )
}

export default SellerAsideLoader
